import React, { useState, useRef, useEffect } from "react";
import PageWrapper from "./components/PageWrapper";
import { useFormCtx } from "./FormContext";
import useTvType from "./hooks/useTvType";
import * as InfoPanelService from "./services/data/InfoPanelService";
import useMqttClient from "./hooks/useMqttClient";

import * as Helper from "./_Helper";
import * as Const from "./_Const";
import InfoPanelOrdination from "./components/InfoPanelOrdination";
import DigitalClock from "./components/DigitalClock";
import AutoFitText from "./components/AutoFitText";
import Button from "./components/Button";
import HiddenBackButton from "./components/HiddenBackButton";
import MouseTracker from "./components/MouseCursor";
import ScreenSaver from "./components/ScreenSaver";

const info_panel_no_waiting_enabled_title = "Informační panel pro pacienty";
const info_panel_no_waiting_enabled_subtitle = "Jakmile se objeví Vaše jméno na tomto informačním panelu,\njděte ke dveřím ordinace";
const info_panel_no_patient_title = "Aktuálně nikdo nečeká";
const info_panel_no_patient_subtitle = "Prosíme příchozí pacienty, aby vložili průkaz totožnosti do registračního zařízení";
const info_panel_waiting_title = "Čekající pacienti";
const info_panel_patient_title = "Volaný pacient";
const info_panel_ordination_title = "Ordinace";
const info_panel_name_title = "Jméno";
const info_panel_born_title = "Narozen";
const info_panel_in_queue_title = "Příchod před";
const info_panel_screen_saver_title = "Šetřič obrazovky...";

const testData = {
  ordinationId: 135,
  fontSize: 0,
  skipExamState: false,
  ordinationOrder: 1,
  ordinationState: Const.ORDINATION_STATE_WAIT_FOR_CALL,
  calledPatient: null,

  // calledPatient: {
  //   pid: 1494436,
  //   inQueue: 17709785519065894,
  //   dob: "12/12/1950",
  //   name: "KAREL",
  //   surname: "NOVÁK",
  //   identification: "G50",
  //   nameResolver: "*12.12.", //zobraju se v dle nastaveneho formatu jemna prijmeni jen u volaneho pacienta pridanim data narozeni "*12.12.",
  //   //nameResolver: null,
  //   isWithoutCard: false,
  // },
  // calledPatient: {
  //   pid: 1494371,
  //   inQueue: 17709622454606719,
  //   dob: null,
  //   name: "Bez Průkazu",
  //   surname: "(C41) Pacient",
  //   identification: "C41",
  //   nameResolver: null,
  //   isWithoutCard: true,
  // },
  ordinationLabel: {
    prefix: "MUDr.",
    part1: "Jana",
    part2: "Nováková",
    postfix: null,
  },
  waitingItems: [],
};

const testPatData = {
  waitingItems: [
    {
      pid: 1494436,
      inQueue: 17709785519065894,
      dob: "12/12/1950",
      name: "KAREL",
      surname: "NOVÁK",
      identification: "G50",
      nameResolver: null,
      isWithoutCard: false,
    },
    {
      pid: 1494260,
      inQueue: 17709766454606719,
      dob: "14/03/1981",
      name: "Petr",
      surname: "Boleslav",
      identification: "U26",
      nameResolver: null,
      isWithoutCard: false,
    },
    {
      pid: 1494261,
      inQueue: 17709622454606719,
      dob: "17/09/1955",
      name: "Blanka",
      surname: "Šrůmová",
      identification: "V12",
      nameResolver: null,
      isWithoutCard: false,
    },
    {
      pid: 1494262,
      inQueue: 17709622454606719,
      dob: "19/04/1991",
      name: "Martina",
      surname: "Sáblíková",
      identification: "S12",
      nameResolver: null,
      isWithoutCard: false,
    },
    {
      pid: 1494263,
      inQueue: 17709622454606719,
      dob: "24/10/1971",
      name: "Radek",
      surname: "Duda",
      identification: "A69",
      nameResolver: null,
      isWithoutCard: false,
    },
    {
      pid: 1494264,
      inQueue: 17709622454606719,
      dob: "12/05/1965",
      name: "Karel",
      surname: "Poborský",
      identification: "D92",
      nameResolver: null,
      isWithoutCard: false,
    },
    {
      pid: 1494265,
      inQueue: 17709622454606719,
      dob: "24/11/1978",
      name: "Roman",
      surname: "Vopat",
      identification: "C52",
      nameResolver: null,
      isWithoutCard: false,
    },
    {
      pid: 1494266,
      inQueue: 17709622454606719,
      dob: "04/03/1956",
      name: "Jaroslav",
      surname: "Nedvěd",
      identification: "C56",
      nameResolver: null,
      isWithoutCard: false,
    },
    {
      pid: 1494267,
      inQueue: 17709622454606719,
      dob: "14/01/1950",
      name: "Andrej",
      surname: "Babiš",
      identification: "A21",
      nameResolver: null,
      isWithoutCard: false,
    },
    {
      pid: 1494268,
      inQueue: 17709622454606719,
      dob: "10/12/1971",
      name: "Kateřina",
      surname: "Novotná",
      identification: "H62",
      nameResolver: null,
      isWithoutCard: false,
    },
    {
      pid: 1494269,
      inQueue: 17709622454606719,
      dob: "11/05/1988",
      name: "Jana",
      surname: "Krátochvílová",
      identification: "X12",
      nameResolver: null,
      isWithoutCard: false,
    },
    {
      pid: 1494371,
      inQueue: 17709622454606719,
      dob: null,
      name: "Bez Průkazu",
      surname: "(C41) Pacient",
      identification: "C41",
      nameResolver: null,
      isWithoutCard: true,
    },
    {
      pid: 1494272,
      inQueue: 17709622454606719,
      dob: "12/08/1985",
      name: "Jan",
      surname: "Novodvorský",
      identification: "P22",
      nameResolver: null,
      isWithoutCard: false,
    },
    {
      pid: 1494273,
      inQueue: 17709622454606719,
      dob: "15/10/1975",
      name: "Drohomila",
      surname: "Dvořáková-Frýbová",
      identification: "G12",
      nameResolver: null,
      isWithoutCard: false,
    },
    {
      pid: 1494274,
      inQueue: 17709622454606719,
      dob: "188/02/2010",
      name: "Dominika",
      surname: "Býmová",
      identification: "S44",
      nameResolver: null,
      isWithoutCard: false,
    },
    {
      pid: 1494275,
      inQueue: 17709622454606719,
      dob: "01/01/2008",
      name: "Filip",
      surname: "Novák",
      identification: "K24",
      nameResolver: null,
      isWithoutCard: false,
    },
    {
      pid: 1494276,
      inQueue: 17709622454606719,
      dob: "18/10/1958",
      name: "Jarmil",
      surname: "Vocásek",
      identification: "H28",
      nameResolver: null,
      isWithoutCard: false,
    },
  ],
};

const testDataGrouped = [
  {
    ordinationId: 200,
    fontSize: 0,
    skipExamState: false,
    ordinationOrder: 1,
    ordinationState: 3,
    calledPatient: {
      pid: 1494437,
      inQueue: 17709789271459050,
      dob: "12/12/1952",
      name: "KAREL",
      surname: "NOVÁK",
      identification: "O85",
      nameResolver: null,
      isWithoutCard: false,
    },
    ordinationLabel: {
      prefix: "Dveře",
      part1: "101 - ",
      part2: "Vyšetření",
      postfix: null,
    },
    doorLabel: null,
    waitingItems: [],
  },
  {
    ordinationId: 201,
    fontSize: 0,
    skipExamState: false,
    ordinationOrder: 2,
    ordinationState: 4,
    calledPatient: null,
    ordinationLabel: {
      prefix: "Dveře",
      part1: "102 - ",
      part2: "Kontrola",
      postfix: null,
    },
    doorLabel: null,
    waitingItems: [],
  },
  {
    ordinationId: 202,
    fontSize: 0,
    skipExamState: false,
    ordinationOrder: 3,
    ordinationState: 4,
    calledPatient: null,
    ordinationLabel: {
      prefix: "Dveře",
      part1: "103 - ",
      part2: "recept",
      postfix: null,
    },
    doorLabel: null,
    waitingItems: [],
  },
];

// const defaultInfoPanelState = {
//   blinkCount: 0,
//   blinkDelay: 0,
//   callInMessage: "",
//   callInPanelMessage: "",
//   digitalRemoveBlackBar: false,
//   doNotEntryMessage: "",
//   doNotEntryPanelMessage: "",
//   groupedPanelWeightSum: 0,
//   hideClock: false,
//   itemPageOffset: 0,
//   itemsOnPage: 0,
//   nameFormat: 0,

//   rootLayoutMarginBottom: 0,
//   rootLayoutMarginLeft: 0,
//   rootLayoutMarginRight: 0,
//   rootLayoutMarginTop: 0,
//   showInQueueTime: false,
//   showPositionNumbers: false,
//   topRightLabel: "",
//   twoColumnsEnabled: false,
//   type: 0,
//   waitForCallPanelMessage: "",
//  "ordinations": [
//             {
//                 "ordinationId": 135,
//                 "order": 1,
//                 "prefix": "MUDr.",
//                 "part1": "Jana",
//                 "part2": "Nováková",
//                 "postfix": null,
//                 "color": null,
//                 "doorLabel": "Dvere 105",
//                 "skipExamState": false,
//                 "fontSize": 0,
//                 "ordinationDirectionID": -1
//             }
//         ]
// };

function PageInfoPanel() {
  const screenType = useTvType();
  const [isScreenSaverActive, setScreenSaverActive] = useState(false);
  const { infoPanelState, playGong, navigateHome, isDebugMode, isDebugModeBackBtnClickable, handleDebug, instance, getUid, loaded } = useFormCtx();
  const { isConnected, messages, publish, lastMessage } = useMqttClient(Const.TERMINAL_APP_SERVICE_WEB_SOCKET_URL, Const.TOPIC_MQTTT_LOCAL);
  const [lastProcessedMessage, setLastProcessedMessage] = useState(null);

  const isSingle = infoPanelState?.type === Const.INFO_PANEL_TYPE_SINGLE;
  const isGrouped = infoPanelState?.type === Const.INFO_PANEL_TYPE_GROUPED;

  const [data, setData] = useState();
  const [isAnyWaitingPatient, setAnyWaitingPatient] = useState(true);

  const showTestButtons = true;
  const testDataCount = 18;
  const { isMoreWaitingPatients } = checkMoreWaitingPatients();

  useEffect(() => {
    async function scopedLoadData() {
      //console.log(isSingle, isGrouped);

      //loada data
      if (loaded) {
        await getInfoPanelData();
      }
    }

    scopedLoadData();
  }, [loaded]);

  //nastaveni barvy v Body na bilou pro info panel - v aplikaci je svetle zelena
  useEffect(() => {
    // Nastavíme barvu body při "namontování" komponenty
    document.body.classList.add("bg-info-panel-bg");

    // Cleanup funkce: vrátí barvu zpět, když komponentu zavřeš
    return () => {
      document.body.classList.add("bg-info-panel-bg");
    };
  }, []);

  //volat jen kdyz se zmeni state nebo lastMessage a je zarovne proveden onload
  useEffect(() => {
    if (lastMessage) {
      //zavolam to abych stanovil state
      handleMqttMessage(lastMessage);
    }
  }, [lastMessage]);

  function getRootMargin() {
    const left = infoPanelState?.rootLayoutMarginLeft ?? 0;
    const right = infoPanelState?.rootLayoutMarginRight ?? 0;
    const top = infoPanelState?.rootLayoutMarginTop ?? 0;
    const bottom = infoPanelState?.rootLayoutMarginBottom ?? 0;

    let isAnyValSet = false;
    if (left != 0 || right != 0 || top != 0 || bottom != 0) {
      isAnyValSet = true;
    }

    //console.log(left, top, right, bottom);

    return { left, top, right, bottom, isAnyValSet };
  }

  function getCssFor(what) {
    let css = "";
    if (screenType === Const.SCREEN_TV_720) {
      switch (what) {
        case "screen-h":
          css = 688;
          break;
        case "div-waiting-h":
          css = 525;
          break;
      }
    } else if (screenType === Const.SCREEN_TV_768) {
      switch (what) {
        case "screen-h":
          css = 735;
          break;
        case "div-waiting-h":
          css = 575;
          break;
      }
    } else if (screenType === Const.SCREEN_TV_1080) {
      switch (what) {
        case "screen-h":
          css = 1040;
          break;
        case "div-waiting-h":
          css = 814;
          break;
      }
    } else if (screenType === Const.SCREEN_TV_2160) {
      switch (what) {
        case "screen-h":
          css = 2090;
          break;
        case "div-waiting-h":
          css = 1640;
          break;
      }
    } else {
      //pro test
      switch (what) {
        case "screen-h":
          css = 688;
          break;
        case "div-waiting-h":
          css = 525;
          break;
      }
    }

    return css;
  }

  async function handleMqttMessage(newMessage) {
    //console.log("handleMqttMessage", newMessage, lastProcessedMessage);

    //nezpracovavat stejnou message vicekrat
    if (lastProcessedMessage !== newMessage) {
      setLastProcessedMessage(newMessage);
      console.log(new Date().toISOString(), "handleMqttMessage", newMessage);
      // Speciální logika pro téma RPi
      if (newMessage?.topic === Const.TOPIC_MQTTT_LOCAL) {
        //pro info panel chodi zpravy ve formatu L_M_T_I_P_C_P|200:1494260:3:1458715
        //200 - ordinationId,
        //1494260 - patientId,
        //3 - stateId
        //1458715 - notificationId
        const { message, payload } = splitMessage(newMessage?.payload);

        switch (message) {
          case Const.LOCAL_MESSAGE_TERMINAL_INFO_PANEL_PATIENT_ADDED:
          case Const.LOCAL_MESSAGE_TERMINAL_INFO_PANEL_REFRESH_DATA:
          case Const.LOCAL_MESSAGE_TERMINAL_INFO_PANEL_STATE_CHANGE:
          case Const.LOCAL_MESSAGE_TERMINAL_INFO_PANEL_CALL_PATIENT:
            console.log(message, payload);
            const notificationId = (payload && payload[3]) ?? 0;
            await getInfoPanelData();
            await confirmNotificationToApi(notificationId);
            if (isScreenSaverActive) {
              setScreenSaverActive(false);
              console.log("handleMqttMessage ScreenSaver is active - set to active false");
            }

            break;
        }
      }
    }
  }

  async function getInfoPanelData() {
    //console.log("getInfoPanelData :", isSingle, isGrouped, infoPanelState);
    try {
      let response = null;
      let needPlayAnyGong = false;
      if (isSingle) {
        const { data: panelData } = await InfoPanelService.getData(instance, getUid());
        response = panelData;
        const { needPlayGong, modifiedResponse } = handleReceivedOrdinationData(response);
        needPlayAnyGong = needPlayGong;
        response = modifiedResponse;
      } else if (isGrouped) {
        const { data: panelData } = await InfoPanelService.getDataGrouped(instance, getUid());
        //  console.log("panelData", panelData);

        response = panelData;

        for (let index = 0; index < response.length; index++) {
          const ordination = response[index];
          const { needPlayGong, modifiedResponse } = handleReceivedOrdinationData(ordination);
          //jen jeli potreba nejaky gong
          if (needPlayGong) {
            needPlayAnyGong = needPlayGong;
          }
        }
      }

      //vzdy jen 1x za cela data i kdyz je panel grouped
      if (needPlayAnyGong) {
        playGong();
      }

      //console.log("getInfoPanelData - data populated:", response, isSingle, isGrouped);

      setData((prevData) => ({
        ...response, //,
        //lastStateChange: Date.now(),
      }));
    } catch (ex) {
      console.log(ex, ex?.response);
    }
  }

  function handleReceivedOrdinationData(response) {
    let needPlayGong = false;
    let ordinationState = response?.ordinationState ?? Const.ORDINATION_STATE_WAIT_FOR_CALL;

    //check skip exam state
    if (ordinationState === Const.ORDINATION_STATE_EXAMINATION) {
      const ordinationData = getOrdinationStateData(response?.ordinationId);
      const skipExamState = ordinationData?.skipExamState ?? false;
      //console.log("check skipExamState:", response, skipExamState);
      if (skipExamState) {
        response.ordinationState = Const.ORDINATION_STATE_WAIT_FOR_CALL;
        console.log("check skipExamState: skipping ORDINATION_STATE_EXAMINATION and set new state ORDINATION_STATE_WAIT_FOR_CALL");
      }
    }

    if (lastMessage) {
      //need play gong
      const { message, payload } = splitMessage(lastMessage?.payload);
      const payloadOrdinationId = (payload && Helper.tryParseInt(payload[0])) ?? 0;

      //zjistit zda posledni messag je stejna jako stav panelu, aby se neprovadel gong i kdyz nebylo vyvolano
      if (ordinationState === Const.ORDINATION_STATE_CALL_IN && message === Const.LOCAL_MESSAGE_TERMINAL_INFO_PANEL_CALL_PATIENT) {
        needPlayGong = true;

        //set lastStateChange jen tam kde se zmenila stav ordinace
        if (response?.ordinationId === payloadOrdinationId) {
          response.lastStateChange = Date.now();
          console.log(`handleReceivedOrdinationData: nastavuji lastStateChange pro ordinaci ${response.ordinationId}`);
        }
      }

      //console.log("handleReceivedOrdinationData", response, message, payload);
    }

    if (isSingle) {
      if (response?.waitingItems?.length > 0) {
        setAnyWaitingPatient(true);
      } else {
        setAnyWaitingPatient(false);
      }
    }
    return { modifiedResponse: response, needPlayGong };
  }

  async function confirmNotificationToApi(notificationId) {
    try {
      if (notificationId > 0) {
        await InfoPanelService.putNotification(instance, getUid(), notificationId);
        console.log(`Notifikace info panelu ${notificationId} potvrzena v API`);
      } else {
        console.log(`Notifikace info panelu ${notificationId} je 0 nemohu nastavit v API`);
      }
    } catch (ex) {
      console.log(ex, ex?.response);
    }
  }

  function splitMessage(data) {
    //pro info panel chodi zpravy ve formatu L_M_T_I_P_C_P|200:1494260:3:1458715
    //200 - ordinationId,
    //1494260 - patientId,
    //3 - stateId
    //1458715 - notificationId
    const [message, rawPayload] = data?.split("|");
    const payload = rawPayload?.split(":");
    return { message, payload };
  }

  function checkMoreWaitingPatients() {
    let maxItems = 0;
    let dataItems = 0;
    let isMoreWaitingPatients = false;

    if (isSingle) {
      maxItems = infoPanelState?.twoColumnsEnabled ? Const.INFO_PANEL_ROWS_ON_SCREEN * 2 : Const.INFO_PANEL_ROWS_ON_SCREEN;
      dataItems = data?.waitingItems.length; //testDataCount
      isMoreWaitingPatients = dataItems > maxItems;
      //console.log("xxxxxx", dataItems);
    }

    return { isMoreWaitingPatients, maxItems, dataItems };
  }

  function getRows() {
    const rows = isMoreWaitingPatients ? Const.INFO_PANEL_ROWS_ON_SCREEN - 1 : Const.INFO_PANEL_ROWS_ON_SCREEN;
    //console.log(maxItems, dataItems, isMoreWaitingPatients, rows);
    return rows;
  }

  function getH() {
    const h = isMoreWaitingPatients ? "h-[83%]" : "h-[92%]";
    //console.log(h, maxItems, dataItems, isMoreWaitingPatients);
    return h;
  }

  function renderOtherWaitingTitle() {
    const { maxItems, dataItems } = checkMoreWaitingPatients();
    const count = dataItems - maxItems + 2; //2 je offset kdyz se odebere posledni radek z obrazovky
    //console.log("xxx", dataItems, maxItems, count);

    let text1 = "dalších";
    let text2 = "čekajících";
    let text3 = "pacientů";

    switch (count) {
      case 1:
        text1 = "další";
        text2 = "čekající";
        text3 = "pacient";
        break;
      case 2:
      case 3:
      case 4:
        text1 = "další";
        text2 = "čekající";
        text3 = "pacienti";
        break;

      default:
        break;
    }

    return (
      <div>
        a {text1} {count} {text2} {text3}...{" "}
      </div>
    );
  }

  function getInQueueTime(item) {
    const diffMs = Date.now() - item.inQueue / 10000;
    const minuteDiff = Math.floor(diffMs / (1000 * 60)); // Převod ms na minuty

    let timeText = `${minuteDiff} min`;

    if (minuteDiff === 0) {
      timeText = "před chvílí";
    } else if (minuteDiff >= 60) {
      const hours = Math.floor(minuteDiff / 60);
      timeText = `${hours} hod`;
    }
    return timeText;
  }

  function renderPatientRow() {
    const { isMoreWaitingPatients, dataItems, maxItems } = checkMoreWaitingPatients();
    const morePatientSubstractCount = infoPanelState?.twoColumnsEnabled ? 2 : 1;
    const minVal = isMoreWaitingPatients ? Math.min(dataItems, maxItems) : maxItems;
    const displayedItems = isMoreWaitingPatients ? minVal - morePatientSubstractCount : minVal;
    // console.log(displayedItems, maxItems, dataItems, isMoreWaitingPatients);

    function renderItem(item, i) {
      const { part1, part2 } = Helper.formatNamesForInfoPanel(item, infoPanelState);
      return (
        <AutoFitText
          prefix={infoPanelState?.showPositionNumbers ? i + 1 + "." : ""}
          part1={part1}
          part2={part2}
          postfix={infoPanelState?.showInQueueTime ? getInQueueTime(item) : ""}
          px={8}
          justify="justify-left"
          prefixCss="text-info-panel-secondary"
          part1Css="font-bold text-info-panel-primary"
          part2Css="font-normal text-info-panel-secondary"
          postfixCss="text-info-panel-secondary font-light"
          gapX={"gap-x-[0.8em]  tvFullHD:gap-x-[0.8em] tv4K:gap-x-[1.8em]"}
        />
      );
    }

    //return Array.from({ length: displayedItems }).map((_, i) => (

    //  pid: 1494267,
    // inQueue: 17655438594606719,
    // dob: "14/01/1950",
    // name: "Anrej",
    // surname: "Babiš",
    // identification: "A21",
    // nameResolver: null,
    // isWithoutCard: false,

    const patientData = data?.waitingItems.slice(0, displayedItems);

    return patientData.map((item, i) => (
      <React.Fragment key={i}>
        {i < dataItems && <div className="bordera place-content-center px-4 text-xl">{renderItem(item, i)}</div>}

        {/* v pripade prazdnych slotu kde neni pacient vloz prazdnou mezeru */}
        {i >= dataItems && <div>&nbsp;</div>}
      </React.Fragment>
    ));
  }

  if (!data || !loaded) {
    return;
  }

  function setCloseState() {
    setData((prevState) => ({
      ...prevState,
      ordinationState: Const.ORDINATION_STATE_CLOSED,
      lastStateChange: Date.now(),
      calledPatient: null,
    }));
  }

  function setWaitForCallState() {
    setData((prevState) => ({
      ...prevState,
      ordinationState: Const.ORDINATION_STATE_WAIT_FOR_CALL,
      lastStateChange: Date.now(),
      calledPatient: null,
    }));
  }

  function testSetCallInPatientToExamination() {
    const calledPatient = data?.calledPatient;
    const ordinationState = data?.ordinationState;
    //console.log(`calledPatient: ${calledPatient} ordinationState: ${ordinationState}`);

    if (calledPatient != null && ordinationState === Const.ORDINATION_STATE_CALL_IN) {
      const ordinationData = getOrdinationStateData();
      const skipExamState = ordinationData?.skipExamState ?? false;
      console.log(`Odbavuji pacienta: ${calledPatient.pid} skipExamState: ${skipExamState}`);

      setData((prevState) => ({
        ...prevState,
        ordinationState: skipExamState ? Const.ORDINATION_STATE_WAIT_FOR_CALL : Const.ORDINATION_STATE_EXAMINATION,
        lastStateChange: Date.now(),
        calledPatient: null,
      }));
    } else {
      console.warn(
        `Nelze odbavit pacienta: buď je volaný pacient null - calledPatient: ${calledPatient} nebo info panel ordinationState není ve stavu ORDINATION_STATE_CALL_IN(3) -  ordinationState: ${ordinationState}`,
      );
    }
  }

  function testCallFirstPatient() {
    const count = data?.waitingItems?.length;
    //console.log("vyvolani pocet:", count);
    let calledPatient = null;
    if (count >= 1) {
      calledPatient = data?.waitingItems[0]; // pro test vzdy prniho
    }

    if (calledPatient != null) {
      console.log("Vyvolávám pacienta id:", calledPatient.pid);

      setData((prevState) => ({
        ...prevState,
        ordinationState: Const.ORDINATION_STATE_CALL_IN,
        calledPatient: calledPatient,
        lastStateChange: Date.now(),
        waitingItems: prevState.waitingItems.filter((item) => item.pid !== calledPatient.pid),
      }));

      if (count > 1) {
        setAnyWaitingPatient(true);
      } else {
        setAnyWaitingPatient(false);
      }
    } else {
      console.warn(`Nelze provést vyvolání - volaný pacient je null`);
    }
  }

  function addTestPatientToWaitingList() {
    let count = data?.waitingItems?.length;
    //console.log(count);

    if (count < testDataCount) {
      const newPatient = testPatData.waitingItems[count];
      //console.log(newPatient);

      setData((prevState) => ({
        ...prevState, // Zkopíruje všechny stávající klíče (ordinationId, fontSize, atd.)
        waitingItems: [
          ...prevState.waitingItems, // Zkopíruje všechny stávající pacienty v poli
          newPatient, // Přidá nového pacienta na konec
        ],
      }));

      setAnyWaitingPatient(true);
    }
  }

  function getOrdinationStateData(id) {
    //   "ordinations": [
    //             {
    //                 "ordinationId": 135,
    //                 "order": 1,
    //                 "prefix": "MUDr.",
    //                 "part1": "Jana",
    //                 "part2": "Nováková",
    //                 "postfix": null,
    //                 "color": null,
    //                 "doorLabel": "Dvere 105",
    //                 "skipExamState": false,
    //                 "fontSize": 0,
    //                 "ordinationDirectionID": -1
    //             }
    //         ]
    // };
    const ordinationItem = infoPanelState?.ordinations;

    let item = null;
    if (ordinationItem) {
      if (isSingle) {
        item = ordinationItem[0];
      } else if (isGrouped) {
        item = ordinationItem.find((item) => item?.ordinationId === id);
      }
    }

    //console.log("getOrdinationData", id, item, infoPanelState, ordinationItem, ordinationItem[0]);

    return item;
  }

  function getOrdinationData(id) {
    let item = null;

    if (data) {
      if (isGrouped) {
        //chodi to jako {{id=1},{id=2}} a ne jako [{id=1},{id=2}] proto musim pouzit Object.values(data)
        item = Object.values(data).find((item) => item?.ordinationId === id);
      }
    }
    //console.log("getOrdinationData", id, item, infoPanelState, ordinationItem, ordinationItem[0]);

    return item;
  }

  function renderLabelsAndClock() {
    return (
      <div className="-mt-4 py-1 tvFullHD:h-16 tvFullHD:-mt-4 tvFullHD:py-1 tv4K:h-24 tv4K:-mt-4 tv4K:py-1 w-full grid grid-cols-[1fr_auto_1fr] items-center text-info-panel-primary text-center">
        {isSingle && (
          <div className="text-xl tvFullHD:text-4xl tv4K:text-7xl">
            {data?.ordinationState === Const.ORDINATION_STATE_CALL_IN ? info_panel_patient_title : ""}
          </div>
        )}
        {isGrouped && <div className="text-xl tvFullHD:text-4xl tv4K:text-7xl">{info_panel_patient_title}</div>}

        <div className="text-xl tvFullHD:text-4xl tv4K:text-7xl text-info-panel-accent font-bold">
          <>
            {!infoPanelState?.hideClock && <DigitalClock />}
            {infoPanelState?.hideClock && <div>&nbsp;</div>}
          </>
        </div>
        <div className="text-xl tvFullHD:text-4xl tv4K:text-7xl">
          {infoPanelState?.topRightLabel ? infoPanelState?.topRightLabel : info_panel_ordination_title}
        </div>
      </div>
    );
  }

  function getGrupedOrdinationCount() {
    //pro testovani renderovani grouped panelu potrebuji vratit min hodnotu bud z dat nebo v debug testOrdinationCount
    const testOrdinationCount = 10;
    return Math.min(infoPanelState?.ordinations?.length, Const.isDebugMode() ? testOrdinationCount : 10);
  }

  console.log("xx isMoreWaitingPatients", isMoreWaitingPatients);
  //console.log("xxxx isScreenSaverActive:", isScreenSaverActive);

  const { top, left, right, bottom, isAnyValSet } = getRootMargin();

  return (
    <>
      <ScreenSaver onActive={setScreenSaverActive} isActive={isScreenSaverActive} text={info_panel_screen_saver_title} />
      {/* info panel debug arrow */}
      {!isScreenSaverActive && (
        <div className={`${isDebugMode ? "opacity-100" : "opacity-0"} bg-accent-dark absolute left-0 top-0 pl-4 w-full z-10 flex items-center h-24`}>
          {/* zobrazi se pri hidden gestu pro debug mode */}
          <HiddenBackButton onClick={navigateHome} visible={isDebugMode} isClickable={isDebugModeBackBtnClickable} setVisible={handleDebug} />
        </div>
      )}
      {!isScreenSaverActive && isGrouped && (
        <div
          className={`${isAnyValSet ? "" : "mx-4 my-4 tvFullHD:mx-4 tvFullHD:my-4 tv4K:mx-8 tv4K:my-8"} grid grid-rows-[auto_1fr] bg-accenta `}
          style={
            isAnyValSet
              ? {
                  height: `${getCssFor("screen-h") - top - bottom}px`,
                  boxSizing: "border-box",
                  margin: `${top}px ${right}px ${bottom}px ${left}px`,
                }
              : { height: `${getCssFor("screen-h")}px` }
          }
        >
          <div>{renderLabelsAndClock()}</div>
          <div
            className={`${getGrupedOrdinationCount() >= 8 ? "gap-1 tvFullHD:gap-2 tv4K:gap-4" : "gap-2 tvFullHD:gap-4 tv4K:gap-8"}`}
            style={{
              display: "grid",
              gridTemplateRows: `repeat(${getGrupedOrdinationCount()}, minmax(0, 1fr))`,
            }}
          >
            {infoPanelState?.ordinations?.slice(0, getGrupedOrdinationCount()).map((item, index) => (
              <div key={index} className="bg-accenta">
                <InfoPanelOrdination
                  data={getOrdinationData(item?.ordinationId)}
                  infoPanelState={infoPanelState}
                  ordinationItem={getOrdinationStateData(item?.ordinationId)}
                  css={"h-full"}
                  cssMargin={"mx-2 tvFullHD:mx-4 tv4K:mx-8"}
                  ordinationCount={getGrupedOrdinationCount()}
                />
              </div>
            ))}
          </div>
        </div>
      )}
      {!isScreenSaverActive && isSingle && (
        <div
          className={`${isAnyValSet ? "" : "mx-4 my-4 tvFullHD:mx-4 tvFullHD:my-4 tv4K:mx-8 tv4K:my-8"}  grid grid-rows-[auto_1fr] bg-accenta`}
          style={
            isAnyValSet
              ? {
                  height: `${getCssFor("screen-h") - top - bottom}px`,
                  boxSizing: "border-box",
                  margin: `${top}px ${right}px ${bottom}px ${left}px`,
                }
              : { height: `${getCssFor("screen-h")}px` }
          }
        >
          <div className="bg-accenta">
            {renderLabelsAndClock()}
            <InfoPanelOrdination data={data} infoPanelState={infoPanelState} ordinationItem={getOrdinationStateData()} css={"h-20 tvFullHD:h-28 tv4K:h-60"} />
          </div>

          <div className="h-full bg-accent-darka">
            <div className="text-2xl mt-4 tvFullHD:text-4xl tvFullHD:mt-4 tv4K:text-7xl tv4K:mt-8 tv4K:mb-8 text-info-panel-primary text-center">
              {info_panel_waiting_title}
            </div>
            <div
              className="mt-4 p-4 tvFullHD:mt-4 tvFullHD:p-4 tv4K:mt-4 tv4K:p-4  border-2 border-info-panel-primary bg-accenta"
              style={{
                height: `${getCssFor("div-waiting-h") - top - bottom}px`,
              }}
            >
              {!isAnyWaitingPatient && (
                <div className="text-center bg-accenta h-full place-content-center -mt-10">
                  <h1 className="text-7xl tvFullHD:text-9xl tv4K:text-14xl text-info-panel-primary font-bold">{info_panel_no_patient_title}</h1>
                  <p className="text-xl tvFullHD:text-4xl tv4K:text-[68px] tv4K:mt-4 text-info-panel-accent">{info_panel_no_patient_subtitle}</p>
                </div>
              )}
              {isAnyWaitingPatient && (
                <>
                  <div className="text-info-panel-primary text-2xl ml-4 mt-2 tvFullHD:text-4xl tvFullHD:ml-4 tvFullHD::mt-4 tv4K:text-6xl tv4K:ml-8 tv4K:mt-8">
                    Jméno
                  </div>
                  <div
                    style={{ gridTemplateRows: `repeat(${getRows()}, 1fr)` }}
                    className={`grid gap-1 tvFullHD:gap-3 tv4K:gap-4 ${infoPanelState?.twoColumnsEnabled ? "grid-cols-2 grid-flow-col" : ""}  ${getH()} `}
                  >
                    {renderPatientRow(data)}
                  </div>
                  {isMoreWaitingPatients && (
                    <div className="text-2xl tvFullHD:text-4xl text-info-panel-primary tv4K:text-7xl place-content-end font-bold text-center h-[10%] bg-accenta">
                      {renderOtherWaitingTitle()}
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      )}

      {Const.isDebugMode() && showTestButtons && (
        <div className="fixed bottom-0 left-0 right-0 h-16 bg-whitea  flex items-center justify-around px-4">
          <Button title={"Přidat pacienta"} showIcon={false} onClick={addTestPatientToWaitingList} />
          <Button title={"Vyvolat pacienta"} showIcon={false} onClick={testCallFirstPatient} />
          <Button title={"Odbavit pacienta"} showIcon={false} onClick={testSetCallInPatientToExamination} />
          <Button title={"Vyčkejte"} showIcon={false} onClick={setWaitForCallState} />
          <Button title={"Zavřeno"} showIcon={false} onClick={setCloseState} />
          <Button title={"Refresh"} showIcon={false} onClick={getInfoPanelData} />
        </div>
      )}
    </>
  );
}

export default PageInfoPanel;
